// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3QpaJ","row":"Node_row__3dGdF","label":"Node_label__29aqN","footer":"Node_footer__2umQz"};